import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import { Head, Link } from '@inertiajs/vue2'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component('InertiaLink', Link)
Vue.component('InertiaHead', Head)
